import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import {
  getComparisonLabel,
  titleize,
  normalizeSettingsForShowAll,
} from './shared'

export const submissionDataDefinition = {
  type: filters.SUBMISSION_DATA,
  nameKey: 'submissions_data',
  ledgerRequired: true,
  shouldShow(filtersContext) {
    const { submissionData } = filtersContext
    return submissionData?.submission_types?.length > 0
  },
  comparisonModes() {
    return [
      ...CompareMixin.computed.numberComparisonModes(),
      ...CompareMixin.computed.isComparisonMode(),
      ...CompareMixin.computed.isNotComparisonMode(),
      ...CompareMixin.computed.showAllComparisonMode(),
    ]
  },

  activeSubtitle(settings) {
    const { comparisonMode, submissionType, filterDataType, filterDataValue } =
      settings

    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      this.comparisonModes()
    )
    let criteriaLabel
    if (comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      criteriaLabel = I18n.t(
        'companies_overview.filters.comparison_modes.show_all'
      )
    } else {
      criteriaLabel = `${comparisonLabel} ${titleize(
        filterDataValue,
        filterDataType !== 'due_date'
      )}`
    }

    return `${titleize(submissionType)}: ${titleize(
      filterDataType
    )} ${criteriaLabel}`
  },

  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'filterDataValue', null)
  },

  serializeSettings(settings) {
    return {
      submission_type: settings.submissionType,
      filter_data_type: settings.filterDataType,
      filter_data_value: settings.filterDataValue,
      comparison_mode: settings.comparisonMode,
    }
  },

  deserializeSettings(params) {
    return {
      submissionType: params.submission_type,
      filterDataType: params.filter_data_type,
      filterDataValue: params.filter_data_value,
      comparisonMode: params.comparison_mode,
    }
  },
}
